/* eslint-disable import/default */

import React from 'react';
import { render } from 'react-dom';
import Root from './components/Root';
import configureStore from './store/configureStore';
import { StylesProvider, createGenerateClassName } from '@material-ui/core/styles';
import { checkIsPN } from './utils/commonHelper';
import '@mudahmy/mudah-ds/styled.css';

const generateClassName = createGenerateClassName({
  productionPrefix: 'pnd',
  disableGlobal: true,
});

require('./favicon.ico'); // Tell webpack to load favicon.ico

const store = configureStore();

checkIsPN();

render(
  <StylesProvider generateClassName={generateClassName} injectFirst>
    <Root store={store} />
  </StylesProvider>,
  document.getElementById('app'),
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(<NewRoot store={store} />, document.getElementById('app'));
  });
}
